import { omit, uniqueId } from 'lodash';
import { HubspotFieldMapping, HubspotSyncTypes } from 'api/integrations';
import { SingleValue } from 'components/atoms/select';
import {
  PartialHubspotFieldMappingLocalData,
  HubspotFieldMappingLocalData,
} from '../types';

export const getNewMap = (
  integrationId: number,
  resourceMappingConfigId: number,
  externalField: SingleValue,
): PartialHubspotFieldMappingLocalData => ({
  id: uniqueId(),
  integrationId,
  resourceMappingConfigId,
  hubspotField: externalField,
  syncField: externalField?.extra
    ? HubspotSyncTypes.SyncNativeToExternal
    : HubspotSyncTypes.SyncExternalToNative,
  rocketlaneField: undefined,
});

export const serialiseMappingData = (
  mapping: HubspotFieldMappingLocalData,
): HubspotFieldMapping | undefined => {
  if (mapping.hubspotField && mapping.rocketlaneField && mapping.syncField) {
    return {
      ...omit(mapping, 'hubspotField', 'rocketlaneField', 'syncField', 'id'),
      integrationId: mapping.integrationId,
      externalIntegrationType: 'hubspot',
      nativeFieldId: Number(mapping.rocketlaneField.value),
      nativeFieldLabel: mapping.rocketlaneField.label,
      nativeFieldName:
        mapping.rocketlaneField?.name ??
        mapping.rocketlaneField.extra?.fieldName,
      externalFieldId: mapping.hubspotField.value.toString(),
      externalFieldName: mapping.hubspotField.label!,
      syncType: mapping.syncField,
      enabled: true,
    };
  }

  return undefined;
};
